import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TabPanel from '../../shared/Tabs/TabPanel';
import Tabs from '../../shared/Tabs/Tabs';
import appStateSlice from "../../store/appState/appStateSlice";
import ConclaveTab from './ConclaveTab';
import NominateTab from './NominateTab';

const MdConclave = () => {
    const dispatch = useDispatch();
    const tabs = useSelector((state) => state.appState.mdConclaveTabs);
    const activeTab = useSelector((state) => state.appState.activeTab);

    useEffect(() => {
        dispatch(appStateSlice.actions.setActiveTab("Conclave"));
    }, []);

    useEffect(() => {
        if (!tabs.some(item => item.name === activeTab)) {
            dispatch(appStateSlice.actions.setActiveTab("Conclave"));
        }
    }, [activeTab]);



    return (
        <>
            <Tabs tabs={tabs} activeTab={activeTab} />
            <TabPanel value={activeTab} name="Conclave" key="Conclave">
                <ConclaveTab />
            </TabPanel>
            <TabPanel value={activeTab} name="Nominate" key="Nominate">
                <NominateTab />
            </TabPanel>
        </>
    );
};

export default MdConclave;